import { get, httpDelete, patch } from "@readai/common/api";
import type {
  SessionACLDeleteRequest,
  SessionACLPatchRequest,
  SessionACLResponse,
} from "@readai/common/types";
import { withQueryParamsUrl } from "@readai/common/utils";

export const getSessionACL = async (
  sessionId: string,
): Promise<SessionACLResponse> => {
  const json = await get(`/sessions/${sessionId}/acl`, { withCreds: true });
  return json as SessionACLResponse;
};

export const patchSessionACL = async (
  sessionId: string,
  patchRequest: SessionACLPatchRequest,
): Promise<void> => {
  // TODO: handle 403's?
  return patch(`/sessions/${sessionId}/acl`, patchRequest, {
    withCreds: true,
  });
};

export const deleteSessionACL = async (
  sessionId: string,
  deleteRequest: SessionACLDeleteRequest,
): Promise<void> => {
  const url = withQueryParamsUrl(`/sessions/${sessionId}/acl`, {
    session_id: deleteRequest.sessionId,
    entity_id: deleteRequest.entityId,
    entity_kind: deleteRequest.kind,
    ...(deleteRequest.indirectAccess && {
      indirect_access: deleteRequest.indirectAccess,
    }),
  });

  return httpDelete(url, { withCreds: true });
};
